<template lang="pug">
  .course-grid(:body-style="{ padding: '5px' }" style="min-height: 50px")
    course-tag(v-for="course in coursesInGrid" :key="course.cname + course.id + position" :course="course" :course-size="courseSize" :background-color="backgroundColor")
    course-query.hidden-sm-and-down(v-if="showCourseInput" v-show="isEditable" ref="saveTagInput" :course-size="courseSize" :position="position" :show-course-input.sync="showCourseInput")
    transition(v-else name="el-fade-in")
      a-button.hidden-sm-and-down.button-new-tag( icon="plus" v-show="isEditable && hoverOn.weekday + hoverOn.timeslot === position" size="small" :body-style="{ padding: '5px' }" @click="showQueryInput")
    a-button.hidden-md-and-up(v-show="coursesInGrid.length === 0" icon="plus" size="small" @click="promptCourses")
    el-dialog.hidden-md-and-up(title="搜尋課程" :visible.sync="showPromptCourseInput") 包含{{ position }}的課程
      course-query(:course-size="courseSize" :position="position" :show-course-input.sync="showCourseInput" :show-prompt-course-input.sync="showPromptCourseInput")
      .dialog-footer(slot="footer")
        el-button(@click="showPromptCourseInput = false") 取消
        el-button(type="primary" @click="showPromptCourseInput = false") 新增

</template>
<script>

import CourseTag from "@/components/Element/CourseGrid/CourseTag";
import CourseQuery from "@/components/Element/CourseGrid/CourseQuery";

export default {
  name: 'course-grid-rollback',
  components: {CourseQuery, CourseTag},
  props: {
    position:{}
  },
  data() {
    return {
      showCourseInput: false,
      inputValue: '',
      showPromptCourseInput: false
    }
  },
  computed: {
    coursesInGrid() {
      let courses = this.allSelectedCourses.filter((c) => c.timeSchedules.includes(this.position))
      return courses
    },
    courseSize() {
      return this.courseOption.allowCrash ? "mini" : "large"
    },
    isEditable() {
      let notFocusOn = !this.courseView.addingCourseGrid
      let focusOnMe = this.courseView.addingCourseGrid === this.position
      let courseNotFilled = this.coursesInGrid.length === 0;
      return ((notFocusOn || focusOnMe) &&
          (this.courseOption.allowCrash || courseNotFilled) )
    },
    hoverOn: {
      get() {
        return this.$store.state.viewState.hoverCourseGrid
      },
      set(v) {
        this.$store.state.viewState.hoverCourseGrid = v
      }
    }
  },
  methods: {
    promptCourses() {
      this.showPromptCourseInput = true
    },
    showQueryInput() {
      this.courseView.addingCourseGrid = this.position
      this.showCourseInput = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.courseQuery.$refs.input.focus();
      });
    },
    onPromptCourseSelected(course) {
      this.updateCourse(course);
      this.$store.state.timetableOptions.previewCourse = null
      this.$nextTick(() => {
        this.showCourseInput = false;
        this.inputValue = '';
        this.showPromptCourseInput = false
      });
    },
    backgroundColor(course) {
      if (!course) return '';
      return {
        '必修': 'warning',
        '選修': '',
        '通識': 'danger',
      }[course.type]
    }
  }
}
</script>
<style>
.course-grid {
  height: 80px;
}

.popover-course {
  width: 300px
}

.course-tag {
  margin-left: 0px;
  margin-right: 0px;
}

.button-new-tag {
  margin-left: 10px;
  margin-right: 10px;
  padding-left: 10px;
  padding-right: 10px;
  height: 24px;
  vertical-align: bottom;
}

.input-new-tag {
  font-size: 8px;
  margin-left: 10px;
  margin-right: 10px;
  vertical-align: bottom;
  width: 100%;
}

.course-tag {
}
</style>
